import i18n, { TFunction } from 'i18next';
import { FilterOption } from 'Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementRequestOverview/components/HbtPortfolioLoansInventoryTable/types';
import { errorSeverityMapping, errorSeverityMappingForChipLabel } from './errorSeverityMapping';

type FlatDataItem = {
  errorMessageInfo?: string;
};

type ErrorMetaItem = {
  errorMessageDescriptionID: string;
  errorMessageEnglish: string;
  errorMessageFrench: string;
};

type errorOptionsGroupedReturn = Record<string, FilterOption[]>;

export const errorOptionsGrouped = (
  flatData: FlatDataItem[],
  errorMeta: ErrorMetaItem[],
  t: TFunction<'HbtMasterPool'>
): errorOptionsGroupedReturn => {
  const errorMapping = errorSeverityMapping(t);
  const errorMappingForChipLabel = errorSeverityMappingForChipLabel(t);

  const errorSet = new Map<string, number>();

  flatData.forEach((data) => {
    const errorCodes =
      typeof data?.errorMessageInfo === 'string'
        ? data.errorMessageInfo.split(',').map((code) => code.trim())
        : [];

    errorCodes.forEach((code) => {
      errorSet.set(code, (errorSet.get(code) || 0) + 1);
    });
  });

  const grouped: Record<string, FilterOption[]> = {};

  const buildOptionFromErrorCode = (
    code: string,
    count: number
  ): { option: FilterOption; severityKey: string } => {
    const [severityKey, descriptionId] = code.split(':');
    const meta = errorMeta?.find((error) => error.errorMessageDescriptionID === descriptionId);

    const label = i18n.language === 'en' ? meta?.errorMessageEnglish : meta?.errorMessageFrench;

    const chipLabel = `${
      errorMappingForChipLabel[severityKey as keyof typeof errorMappingForChipLabel]
    } | ${descriptionId} | ${label}`;

    const option = {
      label: descriptionId,
      subLabel: label,
      value: `${severityKey}:${descriptionId}`,
      count,
      severity: severityKey,
      chipLabel
    };

    return { option, severityKey };
  };

  errorSet.forEach((count, code) => {
    const { option, severityKey } = buildOptionFromErrorCode(code, count);
    if (severityKey && !grouped[severityKey]) grouped[severityKey] = [];
    severityKey && grouped[severityKey].push(option);
  });

  const orderedGrouped: Record<string, FilterOption[]> = {};

  Object.entries(errorMapping)
    .map(([severity]) => severity)
    .forEach((item) => {
      if (grouped[item]) {
        orderedGrouped[item] = grouped[item].sort((a, b) =>
          a.label.localeCompare(b.label, undefined, { numeric: true })
        );
      }
    });

  return orderedGrouped;
};
